import React from 'react';
import { Accordion, Card } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import './AccordionMenuItem.css';
import { ContextAwareToggle } from './components/ContextAwareToggle';

interface AccordionMenuItemProps {
  title: string;
  items: Array<{ title: string; href: string }>;
  isShortSideBar: boolean;
  setIsShortSideBar: React.Dispatch<React.SetStateAction<boolean>>;
  isAccordionOpen: boolean;
  setIsAccordionOpen: React.Dispatch<React.SetStateAction<boolean>>;
  IconComponent: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  onHide?: () => void;
}

export const AccordionMenuItem: React.FC<AccordionMenuItemProps> = ({
  title,
  items,
  isShortSideBar,
  isAccordionOpen,
  setIsAccordionOpen,
  IconComponent,
  onHide
}) => {
  const location = useLocation();

  const handleToggle = (): void => setIsAccordionOpen((prev) => !prev);

  return (
    <Accordion
      className="nav flex-column"
      defaultActiveKey="none"
      activeKey={isAccordionOpen ? '0' : ''}
    >
      <Card className="accordion-item">
        <Card.Header style={{ borderBottom: 'none' }}>
          <ContextAwareToggle
            eventKey="0"
            isShortSideBar={isShortSideBar}
            handleToggle={handleToggle}
            IconComponent={IconComponent}
          >
            {title}
          </ContextAwareToggle>
        </Card.Header>
        {isAccordionOpen && (
          <Accordion.Collapse eventKey="0">
            <Card.Body>
              <ul className="nav flex-column">
                {items.map((item, index) => (
                  <li
                    key={index}
                    className={`nav-item ${location.pathname === item.href ? 'active' : ''}`}
                  >
                    <Link
                      to={item.href}
                      onClick={onHide}
                      className="nav-link d-flex align-items-center gap-2"
                    >
                      {item.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </Card.Body>
          </Accordion.Collapse>
        )}
      </Card>
    </Accordion>
  );
};
